var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-content"},[_c('div',{staticClass:"title"},[_vm._v("填充客户数据")]),_c('div',{staticClass:"table-box"},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.data},on:{"on-row-click":_vm.selectData},scopedSlots:_vm._u([{key:"idType",fn:function(ref){
var row = ref.row;
return [_c('div',[_vm._v(" "+_vm._s(_vm._f("filterTable")(row.idType))+" ")])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }